<template>
    <!-- Content Header (Page header) -->
    <div class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1 class="m-0">Productos</h1>
        </div><!-- /.col -->
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><router-link :to="{ name:'dashboard'}">Home</router-link></li>
            <li class="breadcrumb-item active">Productos</li>
          </ol>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container-fluid -->
  </div>
  <!-- /.content-header -->

  <div class="card card-secondary card-outline">
      <div class="card-body">
          <div class="row">
              <div class="col-sm-6">
                  <h2><button class="btn btn-primary btn-md toastrDefaultSuccess" @click="abrirModal('registrar')">Nuevo Producto</button></h2>
              </div>
              <div class="col-sm-3">
                <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <label class="input-group-text" for="inputGroupSelect01">Ordenar:</label>
                </div>
                <select class="custom-select" v-model="ordenar" @change="listarProductos(currentPage,txtBuscar,ordenar)">
                    <option value="no">=== Por registro ===</option>
                    <option value="nombre">Alfabético</option>
                </select>
                </div>
              </div>
              <div class="col-sm-3">
                  <div class="input-group">
                      <input type="search" v-model="txtBuscar" @keyup="listarProductos(currentPage,txtBuscar,ordenar)" class="form-control form-control-md" placeholder="Buscar por nombre">
                      <div class="input-group-append">
                          <button type="submit" class="btn btn-md btn-default">
                              <i class="fa fa-search"></i>
                          </button>
                      </div>
                  </div>
              </div> 
          </div>
          <div class="table-responsive">
              <table class="table table-bordered table-sm table-striped">
                  <thead class="bg-secondary">
                      <tr>
                          <th>Nombre</th>
                          <th>Descripción</th>
                          <th>Marca</th>
                          <th>Categoria</th>
                          <th>Con Modelo</th>
                          <th>Con Serie</th>
                          <th>Con F.Venc</th>
                          <th>Opciones</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="p in productos" :key="p.id">
                          <td v-text="p.nombre"></td>
                          <td v-text="p.descripcion"></td>
                          <td v-text="p.marca"></td>
                          <td v-text="p.categoria"></td>
                          <td>{{p.tieneModelo?"SI":"NO"}}</td>
                          <td>{{p.tieneSerie?"SI":"NO"}}</td>
                          <td>{{p.tieneVencimiento?"SI":"NO"}}</td>
                          <td>
                              <button class="btn btn-sm btn-warning" @click="abrirModal('actualizar', p)"><i class="fas fa-edit"></i></button>&nbsp;
                              <button v-if="p.activo" class="btn btn-sm btn-danger" @click="eliminarProducto(p.id,p.nombre,p.activo)"><i class="fas fa-trash-alt"></i></button>
                              <button v-else class="btn btn-sm btn-success" @click="eliminarProducto(p.id,p.nombre,p.activo)"><i class="fas fa-trash-restore-alt"></i></button>&nbsp;
                              <span v-if="p.activo" class="badge badge-success">Habilitad</span>
                            <span v-else class="badge badge-danger">Anulado</span>
                          </td>
                      </tr>
                  </tbody>
              </table>
          </div>
           <!-- Agrega el paginador aquí -->
          <div class="row">
              <div class="col-sm-6">
                  <span>Registros: {{ totalRegistros }}</span>
              </div>
              <div class="col-sm-6">
                  <ul class="pagination pagination-sm justify-content-end">
                      <li class="page-item"  :class="{disabled: isOnFirstPage}">
                          <a class="page-link" @click="goToFirstPage" :disabled="isOnFirstPage">Primero</a>
                      </li>
                      <li class="page-item"  :class="{disabled: isOnFirstPage}">
                          <a class="page-link" @click="goToPreviousPage" >Anterior</a>
                      </li>
                      <li class="page-item" :class="{ active: currentPage === page }" v-for="page in visiblePages" :key="page">
                          <a class="page-link" @click="goToPage(page)">{{ page }}</a>
                      </li>
                      <li class="page-item" :class="{disabled: isOnLastPage}">
                          <a class="page-link" @click="goToNextPage" >Siguiente</a>
                      </li>
                      <li class="page-item" :class="{disabled: isOnLastPage}">
                          <a class="page-link" @click="goToLastPage" :disabled="isOnLastPage">Último</a>
                      </li>
                  </ul>
              </div>
          </div>
      </div>      

  </div><!-- /.card -->

  <!--- MODAL PEDIDO --->
     <div v-if="showModal">
      <div class="modal">
          <div class="modal-overlay"></div>
              <div class="modal-content" v-on:keyup.enter = "tipoAccion==1?registrarProducto():actualizarProducto()">
                  <div class="modal-header bg-primary text-white">
                      <h4>{{tituloModal}}</h4>
                      <button type="button" class="close" @click="cerrarModal()">&times;</button>
                  </div>
                  <div class="modal-body">
                      <div class="mb-3 row">
                          <label for="" class="col-sm-3 col-form-label">Nombre: *</label>
                          <div class="col-sm-9">
                              <input type="text" class="form-control" v-model="nombre" placeholder="Nombre del producto" style="text-transform:uppercase;">
                          </div>
                      </div>
                      <div class="mb-3 row">
                        <label for="" class="col-sm-3 col-form-label">Descripción:</label>
                        <div class="col-sm-9">
                            <input type="text" class="form-control" v-model="descripcion" placeholder="Descipcion del producto" style="text-transform:uppercase;">
                        </div>
                    </div>
                    <div class="mb-3 row">
                        <label for="" class="col-sm-3 col-form-label">Marca: </label>
                        <div class="col-sm-9">
                          <select v-model="marca"  class="form-control">
                              <option :value="null">==seleccione==</option>
                              <option :value="ma.id" v-for="ma in marcas" :key="ma.id" v-text="ma.nombre"></option>
                          </select>
                        </div>
                      </div>
                      <div class="mb-3 row">
                          <label for="" class="col-sm-3 col-form-label">Categoria: *</label>
                          <div class="col-sm-9">
                            <select v-model="categoria"  class="form-control">
                                <option :value="null">==seleccione==</option>
                                <option :value="ca.id" v-for="ca in categorias" :key="ca.id" v-text="ca.nombre"></option>
                            </select>
                          </div>
                      </div>
                      
                    <div class="mb-3 row" v-if="tipoAccion==1">
                        <label for="" class="col-sm-3 col-form-label">Cantidad Stock: </label>
                        <div class="col-sm-9">
                            <input type="number" class="form-control" v-model.number="cantidadStock" placeholder="0">
                        </div>
                    </div>
                    <div class="mb-3 row" v-if="tipoAccion==1">
                        <label for="" class="col-sm-3 col-form-label">Precio x Unidad: </label>
                        <div class="col-sm-9">
                            <input type="number" class="form-control" v-model.number="precioxunidad" placeholder="0">
                        </div>
                    </div>
                    <div class="mb-3 row">
                        <label class="col-sm-12 text-danger">
                            *Si el producto no es genérico, considera marcar estas opciones para que sea único
                        </label>
                    </div>
                      <div class="mb-3 row">
                          <label for="" class="col-sm-3 col-form-label">Tiene Modelo:</label>
                          <div class="col-sm-9">
                            <div class="form-check mt-2">
                                <input type="checkbox" class="form-check-input" v-model="modelo" value="modelo">  
                            </div>   
                          </div>
                      </div>
                      <div class="mb-3 row">
                          <label for="" class="col-sm-3 col-form-label">Tiene Serie:</label>
                          <div class="col-sm-9">
                            <div class="form-check mt-2">
                                <input type="checkbox" class="form-check-input" v-model="serie">
                            </div>   
                          </div>
                      </div>
                      <div class="mb-3 row">
                        <label for="" class="col-sm-3 col-form-label">Tiene Fecha Venc:</label>
                        <div class="col-sm-9">
                            <div class="form-check mt-2">
                                <input type="checkbox" class="form-check-input" v-model="fvencimiento">
                            </div>   
                        </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                      <button type="button" class="btn btn-secondary" @click="cerrarModal()">Cerrar</button>
                      <button type="button" v-if="tipoAccion==1" class="btn btn-primary" @click="registrarProducto()">GUARDAR</button>
                      <button type="button" v-if="tipoAccion==2" class="btn btn-primary" @click="actualizarProducto()">ACTUALIZAR</button>
                  </div>
              </div>
          </div>
          
      </div>
  <!--- FIN MODAL PEDIDO --->
    <!-- Loading Overlay -->
    <div v-if="loading" class="loading-overlay">
        <div class="spinner-border text-light" role="status" style="width: 5rem; height: 5rem;">
        <span class="sr-only">Grabando...</span>
        </div>
        <p class="text-light mt-3">Procesando producto, espere...</p>
    </div>
</template>

<script>
    export default{
      data(){
          return{
              id:'',
              nombre:'',
              unidadMedida:null,
              descripcion:'',
              modelo:false,
              serie:false,
              fvencimiento:false,
              categoria:null,
              marca:null,
              cantidadStock:1,
              precioxunidad:0,

              showModal: false,
              tituloModal: '',
              productos: [],
              categorias: [],
              marcas: [],
              errorProducto:0,
              arrayMostMsj:[],
              errorSaveUpdate:[],
              tipoAccion: 0,
              txtBuscar:'',
              idEmpresa:'',
              ordenar:'no',

              currentPage: 1,
              totalPages: 0,
              listporPage: 15, // paginador coincide con DRF
              visiblePages: [], // Páginas visibles en el paginado
              totalPagesToShow: 5, // Cantidad de páginas visibles en el paginado
              totalRegistros:0,
              localeSocket:null,
              loading: false,
          }
      },
      computed: {
          isOnFirstPage() {
          return this.currentPage === 1;
          },
          isOnLastPage() {
          return this.currentPage === this.totalPages;
          },
      },
      methods:{
          updateVisiblePages() {
              const halfTotalPagesToShow = Math.floor(this.totalPagesToShow / 2);

              let startPage = Math.max(this.currentPage - halfTotalPagesToShow, 1);
              let endPage = Math.min(this.currentPage + halfTotalPagesToShow, this.totalPages);

              if (this.totalPages > this.totalPagesToShow) {
                  // Si el número de páginas es mayor que el total de páginas a mostrar, ajustamos los extremos
                  if (endPage === this.totalPages) {
                  startPage = Math.max(endPage - this.totalPagesToShow + 1, 1);
                  } else if (startPage === 1) {
                  endPage = Math.min(startPage + this.totalPagesToShow - 1, this.totalPages);
                  }
              }

              this.visiblePages = Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
          },
          goToPage(pageNumber) {
              // Cambiar la página actual al número de página seleccionado
              this.currentPage = pageNumber;
              // Llamar al método para obtener los datos de la página seleccionada
              this.listarProductos(pageNumber,'',this.ordenar);
          },
          goToPreviousPage() {
              if (this.currentPage > 1) {
                  this.currentPage -= 1;
                  this.listarProductos(this.currentPage,'',this.ordenar);
              }
          },
          goToNextPage() {
              if (this.currentPage < this.totalPages) {
                  this.currentPage += 1;
                  this.listarProductos(this.currentPage,'',this.ordenar);
              }
          },
          goToFirstPage() {
              if (this.currentPage !== 1) {
                  this.currentPage = 1;
                  this.listarProductos(this.currentPage,'',this.ordenar);
              }
          },

          goToLastPage() {
              if (this.currentPage !== this.totalPages) {
                  this.currentPage = this.totalPages;
                  this.listarProductos(this.currentPage,'',this.ordenar);
              }
          },
          listarProductos(pageNumber = 1,txtBuscar,ordenar){
              let me = this
              this.$axios.get(`apinventario/productos/?page=${pageNumber}&search=${txtBuscar}&ordenar=${ordenar}&idEmpresa=${me.idEmpresa}`)
              .then(function(response){
                  me.productos = response.data.results
                  me.currentPage = pageNumber
                  me.totalPages = Math.ceil(response.data.count / me.listporPage)
                  me.totalRegistros = response.data.count
                  me.updateVisiblePages()
              })

          },
          validarProducto(){
              this.errorProducto = 0
              this.arrayMostMsj = []
              if(!this.categoria) this.arrayMostMsj.push("Seleccione una categoria")
              if(!this.nombre.trim()) this.arrayMostMsj.push("Ingrese el nombre del producto")
              if(this.tipoAccion==1){// validar solo cuando se graba uno nuevo
                if (isNaN(this.cantidadStock) || this.cantidadStock <= 0 || !/^\d+$/.test(this.cantidadStock) ) {
                    this.arrayMostMsj.push("Corrige la cantidad: debe ser un número positivo")
                }
                if (isNaN(this.precioxunidad) || this.precioxunidad <= 0 || !/^\d+(\.\d+)?$/.test(this.precioxunidad)) {
                    this.arrayMostMsj.push("Corrige el precio: debe ser un número positivo (ej. 1, 1.0, 5.5, 100.4)")
                }
              }
              
              if(this.arrayMostMsj.length) this.errorProducto = 1
              return this.errorProducto
          },
          registrarProducto(){
              if(this.validarProducto()){
                  this.arrayMostMsj.forEach(element => {
                      this.$toastr.error(element,'Atencion!')
                  });
                  return
              }
              let me = this
              me.loading=true,
              this.$axios.post(`apinventario/productos/`, {
                  nombre: (me.nombre.toUpperCase()).trim(),
                  unidadMedida: me.unidadMedida,
                  descripcion: (me.descripcion.toUpperCase()).trim(),
                  tieneModelo: me.modelo,
                  tieneSerie: me.serie,
                  tieneVencimiento: me.fvencimiento,
                  idCategoria: me.categoria,
                  idMarca: me.marca,
                  idEmpresa: me.idEmpresa,
                  cantidadStock: me.cantidadStock,
                  precioxunidad: me.precioxunidad,
              })
              .then(function (response) {
                  me.listarProductos(me.currentPage,me.txtBuscar,me.ordenar)
                  me.cerrarModal()
                  console.log(response)
                  me.$toastr.success('Nuevo producto registrado', 'Registrado');
                  me.$socket.send(JSON.stringify({
                    'message': 'nuevo producto'
                  }))
              })
              .catch(function (error) {
                if (error.response) {
                    console.log(error.response.data)
                    if (error.response.data.error) {   // 👈 ahora es "error"
                        me.$toastr.error(error.response.data.error)
                    } else {
                        me.$toastr.error("Ocurrió un error al guardar el producto")
                    }
                } else {
                    me.$toastr.error("Error de conexión con el servidor")
                }
                me.errorSaveUpdate = []          
               })
               .finally(()=>{
                    me.loading = false  // ⬅ ocultar spinner siempre
                })
          },
          actualizarProducto(){
              if(this.validarProducto()){
                  this.arrayMostMsj.forEach(element => {
                      this.$toastr.error(element,'Atencion!')
                  });
                  return
              }
              let me = this
              me.loading=true
              this.$axios.patch(`apinventario/productos/`+me.id+`/`,{
                  nombre: (me.nombre.toUpperCase()).trim(),
                  descripcion: (me.descripcion.toUpperCase()).trim(),
                  tieneModelo: me.modelo,
                  tieneSerie: me.serie,
                  tieneVencimiento: me.fvencimiento,
                  idCategoria: me.categoria,
                  idMarca: me.marca,
              })
              .then(function(response){
                  console.log(response)
                  me.listarProductos(me.currentPage,me.txtBuscar,me.ordenar)
                  me.cerrarModal()
                  me.$toastr.success('Producto actualizado', 'Actualizado');
              })
              .catch(function (error) {
                if(error.response && error.response.data){
                    if(error.response.data.nombre){me.errorSaveUpdate.push(error.response.data.nombre[0])}
                    if(error.response.data.codigo){me.errorSaveUpdate.push(error.response.data.codigo)}
                }
                if(me.errorSaveUpdate.length > 0){
                    me.errorSaveUpdate.forEach(element => {
                        me.$toastr.error(element,'Error')
                    });
                }
                me.errorSaveUpdate = []          
               })
               .finally(()=>{
                    me.loading = false  // ⬅ ocultar spinner siempre
                })
          },
          eliminarProducto(id,nombre,activo){
              let me = this
              this.$swal.fire({
              title: nombre,
              text: activo ? 'Presione Si para eliminar' : 'Presione Si para restaurar',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: activo ? 'Eliminar' : 'Restaurar',
              }).then((result) => {
                me.loading=true
              if (result.isConfirmed) {
                  this.$axios.patch(`apinventario/productos/`+id+`/`,{
                    activo : activo ?  0 : 1,
                  })
                  .then(function(response){
                      console.log(response)
                      me.listarProductos(me.currentPage,me.txtBuscar,me.ordenar)
                      me.cerrarModal()
                      if(activo){me.$toastr.success('Producto deshabilitado', 'Desactivado')}
                      else{me.$toastr.success('Producto Habilitado', 'Habilitado')}
                  })
                  .finally(()=>{
                    me.loading = false  // ⬅ ocultar spinner siempre
                  })
              }else{
                me.loading=false
              }
              })
          },
          abrirModal(action, data=[]){
            //consultamos las categorias
            let me = this
            this.$axios.get(`apinventario/categoriastrue/`)
            .then(function(response){
                me.categorias = response.data
            })
            this.$axios.get(`apinventario/marcastrue/`)
            .then(function(response){
                me.marcas = response.data
            })
            //console.log('hola data '+JSON.stringify(data['categoria'].id))
            switch(action){
                case "registrar":{
                    this.showModal = true
                    this.tituloModal = "Nuevo producto"
                    this.tipoAccion = 1
                    break
                }
                case "actualizar":{
                    this.showModal = true
                    this.tituloModal = "Editar producto"
                    this.id = data['id']
                    this.nombre = data['nombre']
                    this.descripcion = data['descripcion']
                    this.fvencimiento = data['tieneVencimiento']
                    this.modelo = data['tieneModelo']
                    this.serie = data['tieneSerie']
                    this.categoria = data['idCategoria']
                    this.marca = data['idMarca']
                    this.tipoAccion = 2
                    break
                }
            }                
          },
          cerrarModal(){
              this.showModal = false;
              this.id = ''
              this.nombre = ''
              this.descripcion = ''
              this.modelo = false
              this.serie = false
              this.fvencimiento = false
              this.categoria = null
              this.marca = null
              this.unidadMedida=null
              this.categorias=[]
              this.marcas=[]
              this.cantidadStock=1
              this.precioxunidad=0
          },
      },
          
      watch: {
          currentPage() {
          // Actualizar las páginas visibles cuando se cambia la página actual
          this.updateVisiblePages();
          },
          totalPages() {
          // Actualizar las páginas visibles cuando se actualiza el número total de páginas
          this.updateVisiblePages();
          },
      },
      mounted(){
          this.idEmpresa = localStorage.getItem('idEmpresa')
          this.listarProductos(1,'',this.ordenar)
          this.updateVisiblePages()
          
      }
  }
</script>

<style scoped>.modal{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: auto;
}
.modal-overlay{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.modal-content{
  width: 40%;
  background-color: white;
  margin-top: 100px;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}
</style>